<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M14.707 6.707a1 1 0 00-1.414-1.414l-10 10a1 1 0 000 1.414l10 10a1 1 0 001.414-1.414L5.414 16l9.293-9.293zm12 0a1 1 0 00-1.414-1.414l-10 10a1 1 0 000 1.414l10 10a1 1 0 001.414-1.414L17.414 16l9.293-9.293z"/></svg>